import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SETTINGS } from '../config/common.settings';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  allContacts: any;
  Contacts: any;

  constructor(private http: HttpClient) {}

  getAllContacts(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/contacts/get-paged`, payload)
        .subscribe({
          next: (response: any) => {
            this.allContacts = response[0];
            resolve(this.allContacts);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getContactByID(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/contacts/get/${id}`).subscribe({
        next: (response: any) => {
          this.Contacts = response;
          resolve(this.Contacts);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  createContact(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/contacts/create`, payload)
        .subscribe({
          next: (response: any) => {
            this.Contacts = response;
            resolve(this.Contacts);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  updateContact(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/contacts/update`, payload)
        .subscribe({
          next: (response: any) => {
            this.Contacts = response;
            resolve(this.Contacts);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }
}
